import { OnboardingLocation } from '../models/Onboarding/OnboardingLocation'
import { OnboardingOrganization } from '../models/Onboarding/OnboardingOrganization'
import { HostOnboardingSteps, OnboardingSteps } from './constants'

export function getCurrentStepFromLocation(
  location: OnboardingLocation,
): HostOnboardingSteps {
  if (!location.name || !location.description) {
    return HostOnboardingSteps.LocationName
  }

  if (
    !location.address ||
    !location.city ||
    !location.state ||
    !location.zipCode
  ) {
    return HostOnboardingSteps.Address
  }

  if (location.imageUrls.length === 0) {
    return HostOnboardingSteps.LocationPhotos
  }

  if (Object.keys(location.businessHours).length === 0) {
    return HostOnboardingSteps.SetBusinessHours
  }

  return HostOnboardingSteps.Review
}

export function getCurrentStepFromAdvertiserOnboardingState(
  organization: OnboardingOrganization,
): OnboardingSteps {
  if (organization.name === '') {
    return OnboardingSteps.OrganizationName
  }
  return OnboardingSteps.Category
}
